var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReportExplanationStatistics',{attrs:{"summary":_vm.statistics,"loading":_vm.loading,"error":_vm.error,"kind":_vm.kind,"reason-key":_vm.reasonKey},on:{"retry":_vm.loadStatistics}})}
var staticRenderFns = []

export { render, staticRenderFns }